import React, { FC } from 'react';
import { Typography } from '@material-ui/core';

import './Title.scss';

const Title: FC = (props) => {
  return (
    <Typography variant="h5" className="Title-Text">
      {props.children}
    </Typography>
  );
};

export default Title;
